import React from 'react';

import {
  DescriptionList,
  DescriptionItem,
  Stack,
  Typography,
} from '@gogame/components';

const General = ({ data }) => {
  return (
    <DescriptionList disableGutters data={data}>
      <DescriptionItem
        label={'Partner Campaigns'}
        field={'campaigns'}
        valueParser={'commaList'}
      />

      <DescriptionItem
        label={'Partner Adsets'}
        field={'adSets'}
        valueParser={'commaList'}
      />
      <DescriptionItem label={'Partner'} field={'partner.name'} />
      <DescriptionItem label={'Partner Api ID'} field={'partnerApiId'} />

      <DescriptionItem
        label={'Countries'}
        field={'countries'}
        valueParser={'commaList'}
      />

      <DescriptionItem
        label={'Account'}
        field={'account'}
        type={({ value: { id, name }, ...other }) => (
          <Stack direction={'column'} {...other}>
            <Typography>
              {name} (#{id})
            </Typography>
          </Stack>
        )}
      />
    </DescriptionList>
  );
};

export default General;
